import { Link, useParams } from "react-router-dom";
import UnseenPill from "../../components/ui/UnseenPill";
import chatIcon from "../../assets/icons/chat-gold.svg";
import PortalCommercialTable from "../../components/portal/PortalCommercialTable";
import PortalCommercialTaskList from "../../components/portal/PortalCommercialTaskList";
import { RefreshControl } from "../../components/portal/commercialRefresh";
import { CommercialDataProvider, useCommercialData } from "../../store/CommercialDataContext";

// Tabbed "Commercial" page — Checklist / Task List use the same stage buttons
// as the trips deal-card filters.
// URL: /portal/commercial (defaults to the Checklist) or /portal/commercial/:tab.
const TABS = {
    checklist: "checklist",
    "task-list": "task-list",
};

// Stage-button tab (same look as the trips deal-card filters). Total count sits
// before the unassigned bell so both figures stay visible on the inactive tab.
const CommercialTab = ({ to, selected, label, count, countLabel, pillCount, pillLabel, feedbackCount = 0 }) => (
    <Link
        to={to}
        replace
        className={selected ? "button--stage-active" : "button--stage-inactive"}
        aria-current={selected ? "page" : undefined}
    >
        <span className="tab__label">{label}</span>
        <span className="commercial__tab-count">
            {count} {countLabel}
        </span>
        <UnseenPill count={pillCount} label={pillLabel} />
        <UnseenPill count={feedbackCount} label="deals with unresolved feedback" icon={chatIcon} modifier="feedback" />
    </Link>
);

// Both datasets live in CommercialDataProvider, so each tab shows its own
// unassigned bell count even while the other tab is the one on screen.
const PortalCommercialTabs = ({ activeTab }) => {
    const {
        unassignedDealCount,
        unresolvedFeedbackDealCount,
        newTaskCount,
        checklistDeals,
        tasks,
        error,
        loading,
        refreshing,
        lastUpdated,
        refreshAll,
        autoRefresh,
        setAutoRefresh,
    } = useCommercialData();

    return (
        <div className="portal__commercial">
            <div className="portal__filters-container portal__commercial__toolbar">
                <div className="portal__stagefilter_wrapper">
                    <CommercialTab
                        to="/portal/commercial/checklist"
                        selected={activeTab === "checklist"}
                        label="Checklist"
                        count={checklistDeals.length}
                        countLabel="deals"
                        pillCount={unassignedDealCount}
                        pillLabel="unassigned deals"
                        feedbackCount={unresolvedFeedbackDealCount}
                    />
                    <CommercialTab
                        to="/portal/commercial/task-list"
                        selected={activeTab === "task-list"}
                        label="Task List"
                        count={tasks.length}
                        countLabel="tasks"
                        pillCount={newTaskCount}
                        pillLabel="unassigned tasks"
                    />
                </div>

                <RefreshControl
                    spinning={loading || refreshing}
                    autoRefresh={autoRefresh}
                    onToggle={setAutoRefresh}
                    onRefresh={refreshAll}
                    lastUpdated={lastUpdated}
                />
            </div>

            {error && <p role="alert">{error}</p>}
            <div className="portal__commercial__content">
                {activeTab === "checklist" ? <PortalCommercialTable /> : <PortalCommercialTaskList />}
            </div>
        </div>
    );
};

const PortalCommercial = () => {
    const params = useParams();
    const activeTab = TABS[params.tab] ?? "checklist";

    return (
        <section className="home__query home__query--commercial">
            <div className="home__query__content wrap commercial-page">
                <CommercialDataProvider>
                    <PortalCommercialTabs activeTab={activeTab} />
                </CommercialDataProvider>
            </div>
        </section>
    );
};

export default PortalCommercial;
